<div id="container-documentListComponent">
  <!-- top research topic component (only on the first page of search results) -->
  <article *ngIf="topResearchTopic.attributes && showTopTopic" class="container-topResearchTopic">
    <header>
      <h2><a [routerLink]="[profile, 'document', topResearchTopic.docId]"
             (click)="pushTopRTTileClickToGA(topResearchTopic.attributes.title, 'Title Click')"
             [queryParams]="{'searchId': topResearchTopic.attributes.searchId}"
             [innerHTML]="topResearchTopic.attributes.title | pqCleanText"></a></h2>
      <ul>
        <li [innerHTML]="topResearchTopic.attributes.sourceType"></li>
        <li [innerHTML]="topResearchTopic.attributes.pubTitle"></li>
      </ul>
    </header>


    <div class="container-topResearchTopicContent">
      <a (click)="pushTopRTTileClickToGA(topResearchTopic.attributes.title, 'Image Click')" [routerLink]="[profile, 'document', topResearchTopic.docId]"  [queryParams]="{'searchId': topResearchTopic.attributes.searchId}">
        <div class="image"
             [ngStyle]="{ 'background-image': 'url(' + topResearchTopic.attributes.thumbnailImage.src + ')' }"
             [attr.aria-label]="topResearchTopic.attributes.thumbnailImage.altText | pqCleanText:true "></div>
      </a>
      <div class="text">
        <div [innerHTML]="topResearchTopic.attributes.abstract | pqCleanText | pqTruncate: topicCharLimit"></div>
        <a [routerLink]="[profile, 'document', topResearchTopic.docId ]"
           (click)="pushTopRTTileClickToGA(topResearchTopic.attributes.title, 'Read More Click')"
           [queryParams]="{'searchId': topResearchTopic.attributes.searchId}"
           [innerHTML]="'Read more about ' + topResearchTopic.attributes.title | pqCleanText">
        </a>
      </div>
      <div class="container-viewpoints">
        <ul *ngIf="viewpoints && viewpoints.length">
          <li *ngFor="let viewpoint of viewpoints; let i = index">
            <a [routerLink]="[profile, 'document', topResearchTopic.docId ]" [fragment]="'section-1'" [innerHTML]="'Viewpoint ' + (i + 1) + ': ' + viewpoint"></a>
          </li>
        </ul>
      </div>
    </div>
  </article>

  <!--Imagerow -->
  <div class="container-imageResults" *ngIf="showImageRow && images.length">
    <pq-image-results [images]="images" [profile]="profile"></pq-image-results>
  </div>

  <ol class="list-docResults">
    <!--top (1st page) or all results (all other pages) -->
    <li *ngFor="let item of docs; trackBy: trackByFn">
      <article>
        <header>
          <h2>
            <!-- web resources documents -->
            <a *ngIf="item.attributes.externalLink.url" [href]="item.attributes.externalLink.url"
               (click)="handleWebOnlyDoc($event, item.attributes, item.docNo)"
               target="_blank"
               title="Link will open in a new window"
               [innerHTML]="'<sup>[External Link]</sup>' + item.attributes.title | pqCleanText | pqTruncate: titleCharLimit"></a>


          <!-- document title link -->
          <a *ngIf="!item.attributes.externalLink.url"
             [routerLink]="[profile, 'document', item.docId]"
             (click)="pushResultsDocClickToGA(item.docNo, item.attributes.title, item.attributes.sourceType, item.attributes.pubTitle)"
             [queryParams]="{'searchId': item.attributes.searchId}"
             [innerHTML]="item.attributes.title | pqCleanText | pqTruncate: titleCharLimit"></a>
        </h2>
          <ul>
            <li>
              <svg [ngClass]="item.icon">
                <use [attr.xlink:href]="'./assets/img/icons.svg#' + item.icon"></use>
              </svg>
              <span [innerHTML]="item.attributes.sourceType | pqCleanText"></span>
            </li>
            <li class="item-metadata">
            <span [innerHTML]="item.attributes.author | pqAuthorFormat | pqCleanText"
                  *ngIf="item.attributes.author"></span>
              <span [innerHTML]="item.attributes.pubTitle + '. ' | pqCleanText"></span>
              <time pubdate="pubdate">{{item.attributes.pubDate}}.</time>
            </li>
            <li>
              Lexile Score: {{ item.attributes.lexileScore | pqLexileScoreFormat }}
            </li>
            <li *ngIf="item.attributes.hasPdf === 'true'">
              <button type="button" class="pdfLink" (click)="generatePdfLink(item.docNo, item.docId, item.attributes.title, item.attributes.searchId)"> PDF Available</button>
            </li>
          </ul>
        </header>

        <div class="container-abstract">
          <div *ngIf="item.attributes.thumbnailImage && item.attributes.thumbnailImage.src" class="container-image">
            <!-- document title link -->
            <a [routerLink]="[profile, 'document', item.docId]" [queryParams]="{'searchId': item.attributes.searchId}">
              <img src="{{item.attributes.thumbnailImage['src']}}" alt="{{item.attributes.thumbnailImage['altText'] | pqCleanText:true }}"
                   title="{{item.attributes.thumbnailImage['altText'] | pqCleanText:true }}">
            </a>
          </div>
          <div *ngIf="item.attributes.abstract !== ''" [ngClass]="{ 'hasImage' : (item.attributes.thumbnailImage && item.attributes.thumbnailImage.src)  }"
               class="container-text">
            <p [innerHTML]="item.attributes.abstract | pqCleanText | pqTruncate: abstractCharLimit"></p>
          </div>
        </div>
      </article>
    </li>

    <!-- related topics component (only on the first page of search results) -->
    <li *ngIf="showTopTopic && relatedTopicsData.slide && relatedTopicsData.slide.length">
      <div class="container-relatedTopicsImages">
        <pq-imageslider [data]="relatedTopicsData"></pq-imageslider>
      </div>
    </li>

    <!-- bottom section results for page 1 -->
    <li *ngFor="let item of partialDocResults">
      <article>
        <header>
          <h2>
            <!-- web resources documents -->
            <a *ngIf="item.attributes.externalLink.url"
               [href]="item.attributes.externalLink.url"
               (click)="handleWebOnlyDoc($event, item.attributes, item.docNo)"
               target="_blank"
               title="Link will open in a new window"
               [innerHTML]="'<sup>[External Link]</sup>' + item.attributes.title | pqCleanText | pqTruncate: titleCharLimit"></a>

            <!-- document title link -->
            <a *ngIf="!item.attributes.externalLink.url"
               [routerLink]="[profile, 'document', item.docId]"
               (click)="pushResultsDocClickToGA(item.docNo, item.attributes.title, item.attributes.sourceType, item.attributes.pubTitle)"
               [queryParams]="{'searchId': item.attributes.searchId}"
               [innerHTML]="item.attributes.title | pqCleanText | pqTruncate: titleCharLimit"></a>

          </h2>

          <ul>
            <li>
              <svg [ngClass]="item.icon">
                <use [attr.xlink:href]="'./assets/img/icons.svg#' + item.icon"></use>
              </svg>
              <span [innerHTML]="item.attributes.sourceType | pqCleanText"></span>
            </li>
            <li class="item-metadata">
            <span [innerHTML]="item.attributes.author | pqAuthorFormat | pqCleanText" *ngIf="item.attributes.author"
                  class="txt-author"></span>
              <span [innerHTML]="item.attributes.pubTitle + '. ' | pqCleanText"></span>
              <span><time pubdate="pubdate">{{item.attributes.pubDate}}.</time></span>
            </li>
            <li>
              Lexile Score: {{ item.attributes.lexileScore | pqLexileScoreFormat }}
            </li>
            <li *ngIf="item.attributes.hasPdf === 'true' && item.attributes.pdfOnly === 'false'">
              <button type="button" class="pdfLink" (click)="generatePdfLink(item.docNo, item.docId, item.attributes.title, searchId)"> PDF Available</button>
            </li>
          </ul>
        </header>

        <div class="container-abstract">
          <div *ngIf="item.attributes.thumbnailImage && item.attributes.thumbnailImage.src" class="container-image">
            <!-- document title link -->
            <a [routerLink]="[profile, 'document', item.docId]" [queryParams]="{'searchId': item.attributes.searchId}">
              <img src="{{item.attributes.thumbnailImage['src']}}" alt="{{item.attributes.thumbnailImage['altText'] | pqCleanText:true }}"
                   title="{{item.attributes.thumbnailImage['altText'] | pqCleanText:true }}">
            </a>
          </div>
          <div *ngIf="item.attributes.abstract !== ''" [ngClass]="{ 'hasImage' :  (item.attributes.thumbnailImage && item.attributes.thumbnailImage.src)   }"
               class="container-text">
            <p [innerHTML]="item.attributes.abstract | pqCleanText | pqTruncate: abstractCharLimit"></p>
          </div>
        </div>
      </article>
    </li>
  </ol>

  <section class="container-relatedSearches" *ngIf="relatedSearches.length">
    <h3 [innerHTML]="relatedSearchTitle"></h3>
    <pq-term-list [terms]="relatedSearches"></pq-term-list>
  </section>
</div>
